<template>
  <div>
    <div class="head_container" style="min-width:1660px;">
      <div v-show="ban" class="bar">
        <div class="zd" @click="clicknav">
          <img src="../../assets/images/zd.png" alt="">
        </div>
       <router-link :to="{path: '/home'}" class="search" >
       <img src="../../assets/images/svg/logo.svg" alt="">
       </router-link>
      </div>
      <div v-show="navbar" class="navbar" @touchmove.prevent>
        <div class="delete" @click="clicknav1"> <img src="../../assets/images/gb.png" alt=""> </div>
        <div class="logo" @click="clicknav1"> <img src="../../assets/images/svg/logo.svg" alt=""> </div>
        <div class="nav1" @touchmove.prevent>
          <router-link :to="{path: '/home'}" :class="path==='/Home'||path==='/particulars'||path==='/'? 'active':''">系统入口与公告</router-link>
          <router-link :to="{path: '/serve'}" :class="path==='/serve'? 'active':''">常用服务</router-link>
          <router-link :to="{path: '/facilitator'}" :class="path==='/facilitator'? 'active':''">已接入服务商</router-link>
          <router-link :to="{path: '/build'}" :class="path==='/build'? 'active':''">已接入建筑</router-link>
          <router-link to="company" :class="path==='/company'? 'active':''">已接入重点单位</router-link>
          <router-link :to="{path: '/manage'}" :class="path==='/manage'? 'active':''">建筑管理单位</router-link>
           <router-link :to="{path: '/maintenance'}" :class="path==='/maintenance'? 'active':''">维保单位</router-link>
          <router-link :to="{path: '/firehouse'}" :class="path==='/firehouse'? 'active':''">微型消防站</router-link>
          <router-link :to="{path: '/improvement'}" :class="path==='/improvement'? 'active':''" @click.native="resetImprove">改进通知</router-link>
          <a href="manage/" target="_blank" style="cursor: pointer;">消防大数据平台</a>
          <el-button class="but" type="text" @click="dialogVisible = true">群防群治公众号</el-button>
          <el-dialog class="ewm" :visible.sync="dialogVisible"
           width="100%"
           >
            <img class="er" src="../../assets/images/er.png" alt="">
            <p class="tite">
              关注群防群治公众号
              消防安全靠大家
              随手提交身边的安全隐患
            </p>
          </el-dialog>
        </div>
      </div>
      <div class="pc">
        <div v-if="white" class="nav">
          <router-link :to="{path: '/Home'}">
            <div style="display: inherit;">
              <img class="logo_img" src="../../assets/images/logo.png">
              <!-- <div v-if="ENVIRON_MENT === 'ja'" style="position: relative;display: inline-block;top: 0.6rem;text-align: right;">
                <span style="position: relative;font-size: 0.8rem;">静安消防</span><br>
                <span style="position: relative;">蓝盾网</span>
              </div> -->
              <span style="position: relative;">黄浦区智慧消防</span>
            </div>
          </router-link>
          <router-link :to="{path: '/Home'}" :class="path==='/Home'||path==='/particulars'||path==='/'? 'active':''">系统入口与公告</router-link>
          <router-link :to="{path: '/serve'}" :class="path==='/serve'? 'active':''">常用服务</router-link>
          <router-link :to="{path: '/facilitator'}" :class="path==='/facilitator'? 'active':''">已接入服务商</router-link>
          <router-link :to="{path: '/build'}" :class="path==='/build'? 'active':''">已接入建筑</router-link>
          <router-link :to="{path: '/company'}" :class="path==='/company'? 'active':''">已接入重点单位</router-link>
          <router-link :to="{path: '/manage'}" :class="path==='/manage'? 'active':''">建筑管理单位</router-link>
          <router-link :to="{path: '/maintenance'}" :class="path==='/maintenance'? 'active':''">维保单位</router-link>
          <router-link :to="{path: '/firehouse'}" :class="path==='/firehouse'? 'active':''">微型消防站</router-link>
          <router-link :to="{path: '/improvement'}" :class="path==='/improvement'? 'active':''" @click.native="resetImprove">改进通知</router-link>
          <a href="manage/" target="_blank" style="cursor: pointer;">消防大数据平台</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  data () {
    return {
      white: true,
      path: '',
      about: false,
      ban: true,
      ban1: false,
      navbar: false,
      dialogVisible: false,
      text: '',
      url: '',
      ENVIRON_MENT: process.env.ENV_SERVER
    }
  },
  created () {
    console.log('process.env.BASE_URL', process.env.ENV_SERVER)
    if (process.env.ENV_SERVER === 'demo') {
      this.text = '上海'
      this.url = process.env.BASE_URL
      localStorage.setItem('text', this.text)
    } else if (process.env.ENV_SERVER === 'sh') {
      this.text = '上海'
      this.url = process.env.BASE_URL
      localStorage.setItem('text', this.text)
    } else if (process.env.ENV_SERVER === 'ja') {
      this.text = '静安消防'
      this.url = process.env.BASE_URL
      localStorage.setItem('text', this.text)
    } else if (process.env.ENV_SERVER === 'hp') {
      this.text = '黄浦区'
      this.url = process.env.BASE_URL
      localStorage.setItem('text', this.text)
    } else {
      this.text = '上海'
      this.url = 'http://demo.119.net/manage'
      localStorage.setItem('text', this.text)
    }
  },
  mounted () {
    const path = this.$route.path
    if (path === '/aboutusintro' || path === '/aboutusfire' || path === '/society' || path === '/casedetails') {
      this.white = false
    } else {
      this.white = true
    }
    this.path = this.$route.path
    if (path === '/aboutusintro' || path === '/aboutusfire' || path === '/firehouse' || path === '/society') {
      this.about = true
    } else {
      this.about = false
    }
  },
  methods: {
    resetImprove(){
      console.log(this.$route)
      if(this.$route.path==='/improvement'){
        this.$router.go(0);
      }
    },
    clicknav () {
      this.ban = false
      this.ban1 = true
      this.navbar = true
    },
    clicknav1 () {
      this.ban = true
      this.ban1 = false
      this.navbar = false
    },
    opennew () {
      window.open(this.url)
    }
  }
}
</script>

<style lang="less" scoped>
.head_container {
  .logo{
    position: absolute;
    z-index:1;
    a{
      img{
        height: 40px;
      width: 40px;
    }
    }
  }
  .top {
    height: 50px;
    .logo {
      float: left;
      margin-left: 12%;
      a {
        display: block;
        width: 65px;
        height: 30px;
        margin-top: 8px;

      }
    }
    .right {
      float: right;
      margin-right: 5%;
      margin-top: 12px;
      font-weight: 700;
      li{
        float: left;
        height: 20px;
        border-right: 1px solid #26405c;
        padding: 0 20px;
        a {
          display: block;
          font-size: 12px;
          height: 20px;
          line-height: 20px;
        }
      }
    }
  }
  .logo_img{
    // width: 20px;
    height: 31px;
  }
  .nav {
    width: 100%;
    height: 64px;
    text-align: center;
    // position: absolute;
    // left: 50%;
    // transform: translateX(-50%);
    // z-index: 9999;
    // top: -30px;
    background-color: #003A8B;
    a {
      width: 5%;
      font-size: 10px;
      font-weight: 700;
      height: 36px;
      // padding-bottom: 3px;
      margin-right: 2%;
      color: #fff;
      margin-top: 20px;
      // position: relative;
      // top: 40px;
      // img{
      //   box-sizing: border-box;
      //   height: 30px;
      //   z-index: 111111;
      //   position: relative;
      // }
      &:last-child{
        display: inline-block;
        width: 143px;
        height: 27px;
        line-height: 27px;
        background-color: #2274E6;
        border-radius: 4px;
      }
      &:first-child{
        font-size: 10px;
        .logo_img{
          // margin-top: 8px;
          vertical-align: middle;
        }
      }
      span{
        font-size: 14px;
        position: absolute;
        width: 40px;
      }
    }
      .active{
        border-bottom: 3px solid #E8351D;
        padding: 0 4px 21px 4px;
      }
  }
  .nav1 {
    width: 100%;
    height: 30px;
    text-align: center;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    z-index: 9999;
    top: 30px;
    a {
      width: 5%;
      font-size: 14px;
      font-weight: 700;
      height: 36px;
      padding-bottom: 3px;
      margin-right: 40px;
      position: relative;
      img{
        border: 3px solid #ccc;
        padding: 5px;
        box-sizing: border-box;
        display: none;
        position: absolute;
        top: 30px;
        left: -20px;
        width: 100px;
        height: 100px;
      }
     &:last-child{
        margin-right: 0;
        float: right;
        width: 180px;
        height: 36px;
        line-height: 36px;
        background-color: #2274E6;
        border-radius: 4px;
      }
    }
  }
  .active{
    border-bottom: 3px solid #fff;
  }
  .navbar{
    display: block;
  }
  .bar{
    display: none;
  }
}
@media screen and(max-width: 750px){
  .navbar{
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    background:#000;
    z-index: 111111;
  .nav,
  .nav1{
    margin-top: 100px;
    height: 100%;
    a{
      font-weight: normal;
      font-size: 26px;
      width: 100% !important;
      display: block;
      height: 80px;
      line-height: 80px;
      color: #fff;
      &:last-child{
       display: none;
      }
    }
  }
  }
  .active{
    border: none !important;
    color:#ABABAB !important;
  }
  .bar{
    position: fixed;
    width: 100%;
    height: 90px;
    top: 0;
    left: 0;
    background-color: #000;
    display: block !important;
    z-index: 5000;
    div{
      display: inline-block;
    }
    .zd{
      float: left;
       img{
         height: 90px;
          }
    }
    .search{
      position: absolute;
      top: 0;
      left: 50%;
      transform: translateX(-50%);
      img{
         height: 40px;
         margin: 28px;
      }
    }
    .ss{
      float: right;
      img{
        height: 40px;
        margin: 26px;

      }
    }

  }

  .pc{
    display: none !important
  }
  .delete{
    margin-right: 10px;
    width: 100%;
    height: 46px;
    margin-top: 0;
    line-height: 50px;
    color: #111;
    background-color: #000;
    opacity: .9;
    position: relative;
    img{
      float: left;
      width: 30px;
      height: 30px;
      margin: 25px;
    }
  }
   .logo{
      position: absolute;
      top: 0;
      left:50%;
      transform: translateX(-50%);
      img{
         height: 40px;
         margin: 28px;
      }
    }
    .but{
      font-size: 26px;
      color: #fff;
      margin-top: 20px;
    }
    .ewm{
      background-color: #000;
      .tite{
        font-size: 20px;
        color: #fff;
      }
    }
}
</style>
<style>
 .ewm .el-dialog__header,.ewm .el-dialog__body{
    background-color: #000;
  }
 .ewm .el-dialog__headerbtn .el-dialog__close{
    position: fixed;
    font-size: 50px;
    top: -116.5px;
    left: 14px;
    font-weight: 300;
    color: #fff;
    background-color: #000;
  }
</style>



// WEBPACK FOOTER //
// src/components/hpComponents/headerNew.vue